(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------------- Wishlist (localStorage) ---------------- */
  var Wishlist = {
    key: 'hi_wishlist',
    all: function () {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
    },
    save: function (arr) {
      try { localStorage.setItem(this.key, JSON.stringify(arr)); } catch (e) {}
    },
    has: function (h) { return this.all().indexOf(h) > -1; },
    count: function () { return this.all().length; },
    toggle: function (h) {
      if (!h) return false;
      var a = this.all();
      var i = a.indexOf(h);
      var added = false;
      if (i > -1) { a.splice(i, 1); } else { a.push(h); added = true; }
      this.save(a);
      this.sync();
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle: h, added: added, list: a } }));
      return added;
    },
    sync: function () {
      var saved = this.all();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
        var on = saved.indexOf(b.getAttribute('data-wishlist-handle')) > -1;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var c = saved.length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = c;
        el.style.display = c > 0 ? '' : 'none';
      });
    }
  };
  window.HiWishlist = Wishlist;

  /* ---------------- Add to cart ---------------- */
  function flash(btn, cls, ms) {
    btn.classList.add(cls);
    setTimeout(function () { btn.classList.remove(cls); }, ms || 1400);
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var cartDrawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (cartDrawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        if (data.status) { flash(btn, 'is-error'); return; }
        try {
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(data);
          } else {
            var bubble = document.getElementById('cart-icon-bubble');
            if (data.sections && data.sections['cart-icon-bubble'] && bubble) {
              var doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              var fresh = doc.querySelector('#cart-icon-bubble');
              if (fresh) bubble.innerHTML = fresh.innerHTML;
            }
          }
        } catch (e) {}
        flash(btn, 'is-added');
      })
      .catch(function () { btn.classList.remove('is-loading'); flash(btn, 'is-error'); });
  }

  /* ---------------- Delegated clicks ---------------- */
  document.addEventListener('click', function (e) {
    var wl = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (wl) { e.preventDefault(); Wishlist.toggle(wl.getAttribute('data-wishlist-handle')); return; }
    var atc = e.target.closest && e.target.closest('[data-card-atc]');
    if (atc) { e.preventDefault(); addToCart(atc); }
  });

  function init() { Wishlist.sync(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
